import { type Batch } from "../batches"
import { num } from "../data"
import { LAST_MEETING, formatDate, shortDate } from "../dates"

// "Cleared X of Y" since the batch joined the push list, as a bar, plus how
// much moved since the last meeting.
export default function BatchProgress({ batch }: { batch: Batch }) {
  const cleared = batch.startQty - batch.qty
  const percent = Math.round((cleared / batch.startQty) * 100)
  const sinceMeeting = batch.lastMeetingQty === null ? null : batch.lastMeetingQty - batch.qty

  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-baseline justify-between gap-4">
        <span>
          Cleared <span className="font-semibold tabular-nums">{num(cleared)}</span> of{" "}
          <span className="font-semibold tabular-nums">{num(batch.startQty)}</span> since{" "}
          {formatDate(batch.startedOn, { month: "short", day: "numeric", year: "numeric" })}{" "}
          <span className="font-semibold">({percent}%)</span>
        </span>
        <span className="shrink-0"><span className="font-semibold tabular-nums">{num(batch.qty)}</span> left</span>
      </div>
      <div className="h-3 overflow-hidden rounded-full bg-muted">
        <div className="h-full rounded-full bg-primary/30" style={{ width: `${percent}%` }} />
      </div>
      <div>
        Last meeting ({shortDate(LAST_MEETING)}):{" "}
        {sinceMeeting === null ? (
          "not on the list yet"
        ) : (
          <>
            <span className="font-semibold tabular-nums">{num(batch.lastMeetingQty!)}</span> left → now{" "}
            <span className="font-semibold tabular-nums">{num(batch.qty)}</span>{" "}
            <span className="tabular-nums">({sinceMeeting > 0 ? `${num(sinceMeeting)} cleared` : "nothing cleared"})</span>
          </>
        )}
      </div>
    </div>
  )
}
